import(/* webpackMode: "eager" */ "/app/apps/web/src/app/(marketing)/pricing/page.tsx");
